import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { take, takeUntil, tap } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { FORM_CONFIG as formConfig } from '../labels-f6';
import { ProductosInformacionService } from '../../../core/providers/services/productos-informacion/productos-informacion.service';
import { PaisesListarService } from '../../../core/providers/services/paises-listar/paises-listar.service';

import { UtilsService } from '../../../shared/services/utils/utils.service';
import { ProductIdCorreduria, ProductosInformacionResInterface } from '../../../core/interfaces/producto-informacion.interface';
import { FormPropModel } from '../../../core/models/form-prop.model';
import { CountryListModel } from '../../../core/models/country-list.model';
import { SelectMultipleModel } from '../../../core/models/select-multiple.model';
import { Numbers } from 'src/app/utils/constants';
import { PrefijoPaisesService } from 'src/app/core/providers/services/prefijo-paises/prefijo-paises.service';

@Component({
  selector: 'app-travel-students-incoming',
  templateUrl: './travel-students-incoming.component.html',
  styleUrls: ['./travel-students-incoming.component.scss']
})
export class TravelStudentsIncomingComponent implements OnInit, OnDestroy {

  /**
   * @description Es el formulario
   */
  @Input() productIdCorreduria: any[] = [];
  @Input() formData: FormGroup;

  /**
   * @description Es el formulario
   */
  formConfig: any;
  currentStep = 1;
  modifyStepV = '';
  /**
   * @description Subject para finalizar suscripciones
   */
  private finish = new Subject();

  /**
   * @description Es un modelo de datos para el componente de botón
   */
  public dataButton = new FormPropModel({ classes: 'green', label: 'Siguiente' });

  public insuredChoosed: 'Particular' | 'Empresa' = 'Particular';
  /**
   * @description constructor
   * @params productServ
   * @params plSrv
   * @params utSrv
   */
  constructor(
    private productServ: ProductosInformacionService,
    private plSrv: PaisesListarService,
    private utSrv: UtilsService,
    private prefixSrv: PrefijoPaisesService
  ) {
    this.productServ = productServ;
    this.plSrv = plSrv;
    this.utSrv = utSrv;
    this.prefixSrv = prefixSrv;
  }

  newFormConfig: any = {
    ...formConfig
  };
  /**
   * @description Metodo de inicio
   */
  ngOnInit(): void {
    this.newFormConfig.currentStep.pipe(
      take(1)
    ).subscribe(step => {
      this.currentStep = step;
    });
    this.getCurrentStep();
    this.subs();
    this.newFormConfig.guaranteeLimitOfMedicalExpenses.options.list = [];
    const listAseg: any[] = [];
    for (let index = 1; index <= Numbers.number100; index++) {
      listAseg.push({ name: `${index}`, id: index });
    }
    this.newFormConfig.numberOfInsured.options.list = listAseg;
    this.newFormConfig.numberOfInsuredList = listAseg;
    // Conseguimos todos los productos de limite de garantia: 18.000, 30.000...
    this.getLisIniGuaranteeLimitOfMedicalExpenses();
    // Obtenemos el listado de prefijos telefónicos
    this.prefixSrv.getPrefix()
      .pipe(take(1))
      .subscribe((prefijo) => {
        this.newFormConfig.insuredData.prefix.options.list = prefijo;
        this.newFormConfig.emergencyContact.prefix.options.list = prefijo;
      });
    this.plSrv.getCountryList()
      .pipe(take(1))
      .subscribe((paisesList: any[]) => {
        // Pais Destino - Multiple
        const countryList: CountryListModel[] = paisesList.map(s => new CountryListModel(s));
        const multipleCountryList: SelectMultipleModel[] = countryList.map(u => new SelectMultipleModel(u));
        // El primer pais es "Seleccionar" por eso lo eliminamos.
        // multipleCountryList.shift();
        this.newFormConfig.countryDestiny.options.multiple = multipleCountryList;
        // Pais Origen - Simple
        const simpleCountryList: any[] = multipleCountryList.map(r => r.value);
        const simpleCountryListNotSpain: any[] = [];

        for (const element of simpleCountryList) {
          if (element.id !== Numbers.number67) {
            simpleCountryListNotSpain.push(element);
          }
        }

        this.newFormConfig.countryOrigin.options.list = simpleCountryList;
        // this.newFormConfig.countryDestiny.options.list = simpleCountryListNotSpain;
        this.newFormConfig.countryDestiny.options.list = simpleCountryList;
        this.newFormConfig.insuredData.country.options.list = simpleCountryList;
        setTimeout(() => {
          this.formConfig = this.newFormConfig;
        }, Numbers.number100);
      });
  }

  /**
   * @description Metodo de fin
   */
  ngOnDestroy() {
    this.finish.next(true);
  }

  /**
   * @description Cambia el valor del formulario
   */
  private subs(): void {
    if (!this.formData) { return; }
    this.formData.valueChanges.pipe(
      takeUntil(this.finish),
      tap(el => {
      })
    ).subscribe();
  }

  /**
   * @description Consigue el valor de una propiedad del formulario
   */
  public getCurrentStep(): void {
    this.newFormConfig.currentStep.pipe(
      takeUntil(this.finish)
    ).subscribe(step => {
      this.currentStep = step;
    });
  }

  /**
   * @description Cambio de paso, siguiente o anterior
   */
  public modifyStep(ev: 'back' | 'next'): void {
    if (ev === 'next') {
      this.formConfig.stepIncrement();
    }
    if (ev === 'back') {
      this.formConfig.stepDecrement();
    }

    this.modifyStepV = ev;
  }

  /**
   * @description Cambio de tomador particular o empresa
   */
  changeInsuredType(ev: 'Particular' | 'Empresa'): void {
    this.insuredChoosed = ev;
  }

  /**
   * @description Retorna el tipo de tomador particular o empresa
   */
  getInsuredTypeChoosed(): 'Particular' | 'Empresa' {
    return this.insuredChoosed;
  }
  /**
   * @description Preparamos la llamada al servicio par obtener la lista de garantias
   */
  getLisIniGuaranteeLimitOfMedicalExpenses(): void {
    // recuperamos las garantias outgoing
    let arrGarantias: number [] = [Numbers.number17141, Numbers.number17164, Numbers.number17165];
    // arrGarantias = [17084, 17085, 17086];
    if (!(this.productIdCorreduria.length === 1 && this.productIdCorreduria[0] === 0)) {
      this.productIdCorreduria.map(elId => {
        this.listDataGuaranteeLimitOfMedicalExpenses(elId.producto, 'guaranteeOutgoing');
      });
    } else {
      for (const codGarantia of arrGarantias) {
        this.listDataGuaranteeLimitOfMedicalExpenses(codGarantia, 'guaranteeOutgoing');
      }

    }
    // Incoming
    arrGarantias = [Numbers.number17166];
    // arrGarantias = [17087, 17088];
    for (const codGarantia of arrGarantias) {
      this.listDataGuaranteeLimitOfMedicalExpenses(codGarantia, 'guaranteeIncoming');
    }

    // Nacional
    this.listDataGuaranteeLimitOfMedicalExpenses(Numbers.number17141, 'guaranteeNational');
  }
  /**
   * @description Llamamos al servicio para obtener el listado de garantias
   * @param index2 indice del for
   * @param listGuaranteeType tipo de lista donde se guarda guaranteeOutgoing o guaranteeIncoming
   */
  public listDataGuaranteeLimitOfMedicalExpenses(index2: any, listGuaranteeType: any): void {
    this.productServ
      .getProductInfo(index2)
      .pipe(take(1))
      .subscribe((el: ProductosInformacionResInterface) => {
        el.name = this.utSrv.stringToNumber(el.nombreProducto).toString();
        let arrAux: any[] = [];
        if (this.formData.get(['incomingStudentsTravelAsistance', listGuaranteeType])) {
          arrAux = this.formData.get(['incomingStudentsTravelAsistance', listGuaranteeType]).value;
        }
        arrAux.push(el);
        arrAux = arrAux.sort((a, b) => a.name - b.name);
        this.formData.get(['incomingStudentsTravelAsistance', listGuaranteeType]).setValue(arrAux);
      });
  }

}
